import {ArrowRight, Check} from "lucide-react";
import {Link, useParams, useSearchParams} from "react-router-dom";
import {useInviteContextQuery} from "../redux/auth-api";
import {RideShell, RideLoading, RideNotice, SignInPrompt} from "@src/features/quick-actions/ui/ride-shell";
import {AppDownload} from "@src/features/quick-actions/ui/app-download";
import {useRideLanguage} from "@src/features/quick-actions/ride-language";
import {apiMessage, inviteDestination} from "@src/features/quick-actions/ride-utils";

export function InviteSuccessScreen() {
  const {t} = useRideLanguage();
  const {groupId = ""} = useParams();
  const [params] = useSearchParams();
  const context = useInviteContextQuery(groupId, {skip: !groupId, refetchOnMountOrArgChange: 30});
  const session = context.data?.session;
  const member = session?.spacesPublicInfo.some(space => space.spaceId === groupId);
  const login = `/login/${encodeURIComponent(groupId)}?${params}`;
  return <RideShell><div className="ride-auth ride-success">
    {context.isLoading ? <RideLoading/> : context.error ? <RideNotice error>
      {t(apiMessage(context.error, "We couldn’t check your account."))}
      <button className="ride-link" onClick={() => void context.refetch()}>{t("Try again")}</button>
    </RideNotice> : !member ? <SignInPrompt href={login}/> : <section className="ride-panel">
      <span className="ride-booking-icon"><Check aria-hidden="true"/></span>
      <h1>{t("Sign-in successful")}</h1>
      <p className="ride-help">{t("You’re linked to your group.")} <bdi>{context.data?.groupName}</bdi></p>
      <div className="ride-account">
        <p>{t("Sign in to the app with the same phone number:")}</p>
        <strong className="ride-success-phone" dir="ltr">{session?.userFullInfo?.phoneNumber?.replace(/^n/, "")}</strong>
      </div>
      <AppDownload features/>
      <Link className="ride-button ride-button-secondary ride-button-full" to={inviteDestination(groupId, params)} replace>
        {t("Continue on web")}<ArrowRight size={17}/>
      </Link>
    </section>}
  </div></RideShell>;
}
